import React, { useState } from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  NavLink,
  useNavigate,
  useLocation,
} from "react-router-dom";
import Home from "./pages/Home";
import Products from "./pages/Products";
import About from "./pages/About";
import Blogs from "./pages/Blogs";
import BlogDetail from "./pages/BlogDetail";
import "./App.css";

import { FaFacebook, FaInstagram } from "react-icons/fa";
import logo from "./pages/Shiv_Shakti_Logo_HD.png";


const SubNavbar = () => {
  const reddishBrown = "#8B2500";

  return (
    <nav className="subnavbar">
      <div className="subnavbar-inner">
        {/* Static Text */}
        <div className="subnav-text">Monday to Sunday 8:30 AM to 10 PM </div>
        <div className="subnav-text highlight">
           Manufacturer & Wholesaler of Indian Sweets
        </div>

        {/* Social Icons */}
        <div className="subnav-icons">
          <a
            href="https://www.facebook.com/profile.php?id=61578899273637"
            target="_blank"
            rel="noreferrer"
            style={{ color: reddishBrown }}
          >
            <FaFacebook size={22} />
          </a>
          <a
            href="https://www.instagram.com/shivshaktii_sweets/"
            target="_blank"
            rel="noreferrer"
            style={{ color: reddishBrown }}
          >
            <FaInstagram size={22} />
          </a>
        </div>
      </div>
    </nav>
  );
};

// === Main AppWrapper with Navbar and Routes ===
function AppWrapper() {
  const [scrollToContact, setScrollToContact] = useState(false);
  const [navOpen, setNavOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();

  const handleContactClick = (e) => {
    e.preventDefault();
    setNavOpen(false);

    if (location.pathname === "/") {
      setScrollToContact(true);
      setTimeout(() => setScrollToContact(false), 1000);
    } else {
      navigate("/");
      setTimeout(() => {
        setScrollToContact(true);
        setTimeout(() => setScrollToContact(false), 1000);
      }, 300);
    }
  };

  const toggleNav = () => setNavOpen((prev) => !prev);

  return (
    <div>
      {/* === Main Navbar === */}
      <nav className="navbar">
        <div className="navbar-header">
          <div className="logo-wrapper">
            <NavLink to="/">
              <img src={logo} alt="Logo" className="logo" />
            </NavLink>
          </div>
          <button
            className={`hamburger ${navOpen ? "active" : ""}`}
            onClick={toggleNav}
          >
            <span></span>
            <span></span>
            <span></span>
          </button>
        </div>

        <ul className={`nav-links ${navOpen ? "open" : ""}`}>
          <li onClick={() => setNavOpen(false)}>
            <NavLink to="/" end>
              Home
            </NavLink>
          </li>
          <li onClick={() => setNavOpen(false)}>
            <NavLink to="/products">Products</NavLink>
          </li>
          <li onClick={() => setNavOpen(false)}>
            <NavLink to="/about">About Us</NavLink>
          </li>
          <li>
            <a href="/contact" onClick={handleContactClick}>
              Contact
            </a>
          </li>
          <li onClick={() => setNavOpen(false)}>
            <NavLink to="/blogs">Blogs</NavLink>
          </li>
        </ul>
      </nav>

      {/* === SubNavbar (Below Main Navbar) === */}
      <SubNavbar />

      {/* === Routes === */}
      <div className="page-container">
        <Routes>
          <Route path="/" element={<Home scrollToContact={scrollToContact} />} />
          <Route path="/products" element={<Products />} />
          <Route path="/about" element={<About />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/blogs/:id" element={<BlogDetail />} />
        </Routes>
      </div>
    </div>
  );
}

// === App ===
export default function App() {
  return (
    <Router>
      <AppWrapper />
    </Router>
  );
}
